/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// gsap marquee
(() => {
    gsap.ticker.lagSmoothing(1000, 16);

    const marquees = document.querySelectorAll(".sd-marquee");
    if (!marquees.length) return;

    marquees.forEach(initMarquee);

    function initMarquee(marquee) {
        const viewport = marquee.querySelector(".sd-marquee__viewport");
        const sourceTrack = marquee.querySelector(".sd-marquee__track");
        if (!viewport || !sourceTrack) return;

        // ----- OPTIONS (with defaults)
        const speed = parseFloat(marquee.dataset.speed) || 1;
        const direction = marquee.dataset.direction === "right" ? 1 : -1;
        const pauseOnHover = marquee.dataset.pauseOnHover === "true";

        const TRACK_COUNT = 2;

        let tracks = [];
        let trackWidth = 0;
        let paused = false;

        function waitForImages(images, callback) {
        let loaded = 0;
        const total = images.length;

        if (!total) {
            callback();
            return;
        }

        function done() {
            loaded++;
            if (loaded === total) callback();
        }

        images.forEach((img) => {
            if (img.complete) {
            done();
            } else {
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
            }
        });
        }

        function buildTracks() {
        tracks = [];

        tracks.push({ el: sourceTrack, x: 0 });

        for (let i = 1; i < TRACK_COUNT; i++) {
            const clone = sourceTrack.cloneNode(true);
            clone.setAttribute("aria-hidden", "true");
            viewport.appendChild(clone);
            tracks.push({ el: clone, x: 0 });
        }

        requestAnimationFrame(() => {
            trackWidth = sourceTrack.scrollWidth;

            tracks.forEach((t, i) => {
            t.x = i * trackWidth;
            gsap.set(t.el, { x: t.x });
            });

            gsap.ticker.add(tick);
        });
        }

        function tick() {
        if (paused) return;

        tracks.forEach((t) => {
            // t.x += speed * direction;

            const delta = gsap.ticker.deltaRatio(60);
            t.x += speed * direction * delta;

            if (direction < 0 && t.x <= -trackWidth) {
            t.x += trackWidth * tracks.length;
            }

            if (direction > 0 && t.x >= trackWidth * (tracks.length - 1)) {
            t.x -= trackWidth * tracks.length;
            }

            gsap.set(t.el, { x: t.x });
        });
        }

        if (pauseOnHover) {
        marquee.addEventListener("mouseenter", () => (paused = true));
        marquee.addEventListener("mouseleave", () => (paused = false));
        }

        const images = sourceTrack.querySelectorAll("img");
        waitForImages(images, buildTracks);
    }
})();









/**
 * Shopify Subscriptions Widget Enhancement
 * Makes the entire subscription option block clickable (proxying clicks to the radio input)
 * and applies an `.is-active` class to the selected block for styling purposes.
 * Safe to use with Shopify’s dynamically rendered subscription widgets.
 */
(() => {
  function updateSubscriptionActiveStates() {
    document
      .querySelectorAll('.shopify_subscriptions_app_block_label')
      .forEach(block => {
        const radio = block.querySelector('input[type="radio"]');
        block.classList.toggle('is-active', !!radio?.checked);
      });
  }

  // Initial sync (handles pre-selected plans)
  updateSubscriptionActiveStates();

  document.addEventListener('click', function (e) {
    const block = e.target.closest('.shopify_subscriptions_app_block_label');
    if (!block) return;

    const radio = block.querySelector('input[type="radio"]');
    if (!radio) return;

    if (e.target !== radio) {
      radio.click();
    }

    // Ensure state is updated after the radio change
    requestAnimationFrame(updateSubscriptionActiveStates);
  });
})();
